import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { StorageLCPImage } from '@/components/atoms/StorageImage';
interface ActionCardLCPProps {
  title: string;
  backgroundImage?: string;
  actionTypeName?: string;
  celebrity?: {
    firstName: string;
    lastName: string;
    headerAvatarImg?: string;
    isValidated?: boolean;
  };
  tokenReward?: number;
  gemReward?: number;
  tokenCost?: number;
}
export const ActionCardLCP = t0 => {
  const $ = _c(23);
  const {
    title,
    backgroundImage,
    actionTypeName,
    celebrity,
    tokenReward,
    gemReward,
    tokenCost
  } = t0;
  const isSMGrowth = actionTypeName === "sm_growth_celebrity" || actionTypeName === "sm_growth_like" || actionTypeName === "sm_growth_comment" || actionTypeName === "sm_growth_share" || actionTypeName === "sm_growth_follow" || actionTypeName === "sm_growth_subscribe" || actionTypeName === "sm_growth_view" || actionTypeName === "sm_growth_listen" || actionTypeName === "sm_growth_watch";
  let t1;
  if ($[0] !== backgroundImage || $[1] !== celebrity || $[2] !== isSMGrowth || $[3] !== title) {
    t1 = !isSMGrowth ? <div className="absolute inset-0 z-0">{backgroundImage ? <StorageLCPImage src={backgroundImage} alt={title} width={343} height={506} className="h-full w-full object-cover" sizes="(min-width: 1280px) 397px, 343px" /> : <div className="h-full w-full bg-gradient-to-br from-[#1a1a2e] to-[#2a2a3e]" />}</div> : <div className="absolute inset-0 z-0 flex flex-col items-center justify-start gap-5 bg-[linear-gradient(180deg,#121262_0%,#1E1E2A_100%)] pt-[60px]"><div className="w-[35%] overflow-hidden rounded-full border-[10px] border-[#FFFFFF]/10 md:w-[calc(100%/396*200)]"><div className="relative pb-[100%]">{celebrity?.headerAvatarImg && <StorageLCPImage src={celebrity.headerAvatarImg} alt={title} width={200} height={200} className="absolute inset-0 h-full w-full object-cover" sizes="200px" />}</div></div>{celebrity && <p className="bg-[linear-gradient(90deg,#FF4D00_0.26%,#FF8000_100.26%)] bg-clip-text text-center font-[Montserrat] text-[30px] font-bold italic leading-[1] text-[transparent]">{celebrity.firstName} <br />{celebrity.lastName}</p>}</div>;
    $[0] = backgroundImage;
    $[1] = celebrity;
    $[2] = isSMGrowth;
    $[3] = title;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== celebrity || $[6] !== isSMGrowth || $[7] !== title) {
    t2 = !isSMGrowth && <div className="flex flex-col gap-2">{celebrity && <div className="flex items-start gap-2.5"><span className="font-['Inter'] text-[13px] leading-[18px] text-[rgba(255,255,255,0.7)]">{celebrity.firstName} {celebrity.lastName}</span>{celebrity.isValidated && <Image src="/icons/verified-blue.svg" alt="Verified" className="size-5" width={18} height={18} />}</div>}<h3 className="line-clamp-2 min-h-[50px] font-['Inter'] text-[22px] font-medium leading-[1.15] text-[#e9ecf0]">{title}</h3></div>;
    $[5] = celebrity;
    $[6] = isSMGrowth;
    $[7] = title;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== gemReward || $[10] !== tokenReward) {
    t3 = (!!tokenReward || !!gemReward) && <div className="flex flex-col gap-2"><span className="font-['Inter'] text-[14px] leading-[16px] text-[rgba(255,255,255,0.7)]">Reward</span><div className="flex gap-2">{!!gemReward && <div className="flex items-center justify-center gap-1 rounded-[100px] bg-[#e9ecf0] px-3 py-2"><div className="h-[18px] w-[18px]"><Image src="/images/actions/coin.png" alt="Gems" width={18} height={18} /></div><span className="font-['Inter'] text-[16px] font-semibold leading-[1.3] text-black">{gemReward}</span></div>}{!!tokenReward && <div className="flex items-center justify-center gap-1 rounded-[100px] bg-[#e9ecf0] px-3 py-2"><div className="h-[18px] w-[18px]"><Image src="/images/actions/gem.png" alt="Tokens" width={18} height={18} /></div><span className="font-['Inter'] text-[16px] font-semibold leading-[1.3] text-black">{tokenReward}</span></div>}</div></div>;
    $[9] = gemReward;
    $[10] = tokenReward;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== tokenCost) {
    t4 = !!tokenCost && <div className="flex flex-col items-end gap-2"><span className="font-['Inter'] text-[14px] leading-[16px] text-[rgba(255,255,255,0.7)]">Cost</span><div className="flex w-[70px] items-center justify-center gap-1 rounded-[100px] bg-[#4B4B4B] px-3 py-2"><div className="relative h-[18px] w-[18px]"><Image src="/images/actions/coin.png" alt="Tokens" width={18} height={18} /></div><span className="font-['Inter'] text-[16px] font-semibold leading-[1.3] text-[#e9ecf0]">{tokenCost}</span></div></div>;
    $[12] = tokenCost;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t3 || $[15] !== t4) {
    t5 = <div className="mt-auto flex min-h-[70px] items-end justify-between">{t3}{t4}</div>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t2 || $[18] !== t5) {
    t6 = <div className="relative z-10 mt-auto w-full rounded-[14px] bg-[rgba(23,23,35,0.8)] p-4 backdrop-blur-md"><div className="flex min-h-[180px] flex-col gap-4">{t2}{t5}</div></div>;
    $[17] = t2;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t1 || $[21] !== t6) {
    t7 = <div className="relative flex h-[506px] flex-col items-center justify-between overflow-hidden rounded-[20px] md:h-[575px]">{t1}{t6}</div>;
    $[20] = t1;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};